import React, { useEffect, useCallback, useState} from 'react';
import Dropdown from 'react-dropdown';
import CheckboxParameter from "components/effects/CheckboxParameter.js";
import EffectParameterSlider from "components/effects/EffectParameterSlider.js";
import {connect} from 'react-redux';

const OPTIONS = [
    {value: 4, label: 4},
    {value: 6, label: 6},
    {value: 8, label: 8},
    {value: 10, label: 10},
    {value: 16, label: 16},
    {value: 32, label: 32},
];
const FrequencyShifter = ({effect, sequencerEngine}) => { 
    let [numBanks, setNumBanks] = useState(effect.numBanks);
    const onChangeBanks = useCallback(o => {
        let val = o.value;
        effect.numBanks = val;
        setNumBanks({value: val, label: val});
    }, [setNumBanks, effect]);

    return (
        <div>
          <div className="bands-toolbar">
            <div className="bands-label">Number of Banks: </div>
            <Dropdown
              options={OPTIONS}
              onChange={onChangeBanks}
              value={OPTIONS.find(x => x.value === effect.numBanks)}/>
          </div>
         <EffectParameterSlider
            parameter={effect.frequencyParameter}
            min={1}
            lfoEnabled={true}
            max={1000}
            name="Frequency"
            sequencerEngine={sequencerEngine}
            isParameter={true}
          />
          <EffectParameterSlider
            parameter={effect.delaySpreadParameter}
            min={0}
            lfoEnabled={true}
            max={1}
            step={0.0001}
            name="Delay Spread"
            sequencerEngine={sequencerEngine}
            isParameter={true}
          />
          <CheckboxParameter
            name="Reverse delay"
            parameter={effect.delayDirectionParameter}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FrequencyShifter);
